import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { isAllergiesWarningEnabled, getDinnerBookingAllergyInformation } from "state/school_money/selectors";
import { setAllergiesWarningStatus } from "state/school_money/actions";

import ModalDialog from "components/ModalDialog";
import WeekdayTable from "components/WeekdayTable";
import Button from "components/Button";
import Checkbox from "components/Checkbox";

import closeButton from "components/assets/images/close--light.svg";
import "./AllergiesModal.css";

class AllergiesModal extends React.Component {
  
  static propTypes = {
    dinnerBookingID: PropTypes.string.isRequired,
    isWarning: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  }
  
  setAllergiesWarningStatus = (isEnabled) => {
    this.props.setAllergiesWarningStatus(isEnabled);
  }
  
  closePositive = () => {
    this.props.onClose(true);
  }
  
  closeNegative = () => {
    this.props.onClose(false);
  }
  
  render() {
    
    const { allergyInformationList, isOpen, isAllergiesWarningEnabled, isWarning } = this.props;
    
    return (
      <ModalDialog isOpen={isOpen}>
        <div className="allergy-information-body">
          <div className="allergy-information">
            <h1 className="allergy-information__heading">{ isWarning ? "Allergies Warning!" : "Allergies" }</h1>
            <div className="allergy-information__details">
              <WeekdayTable cssBlockName="allergy-information__weekday-table">
                { (weekdayIndex, weekdayName) => (
                  <AllergyInformationRow
                    key={weekdayIndex}
                    weekdayIndex={weekdayIndex}
                    weekdayName={weekdayName}
                    allergyInformationList={allergyInformationList}
                  />
                ) }
              </WeekdayTable>
            </div>
            {
              isWarning ?
              <div className="allergy-information__prompt-text">Do you want to add this week to basket?</div> :
              null
            }
            <div className="allergy-information__button-container">
              <Button className="allergy-information__button">
                <span onClick={this.closePositive}>{ isWarning ? "Yes" : "OK" }</span>
              </Button>
              {
                isWarning ?
                <Button className="allergy-information__button">
                  <span onClick={this.closeNegative}>No</span>
                </Button> :
                null
              }
            </div>
            <div className="allergy-information__warning-toggle">
              <span className="allergy-information__warning-toggle-label">Show Allergy Warnings</span>
              <Checkbox cssModifier="school_money" checked={isAllergiesWarningEnabled} onChange={this.setAllergiesWarningStatus} />
            </div>
          </div>
          <div className="allergy-information__close-button" onClick={this.closeNegative}>
            <img src={closeButton} alt="close" />
          </div>
        </div>
      </ModalDialog>
    );
    
  }
  
}

export default connect(
  (state, ownProps) => ({
    isAllergiesWarningEnabled: isAllergiesWarningEnabled(state),
    allergyInformationList: getDinnerBookingAllergyInformation(state, ownProps.dinnerBookingID)
  }),
  { setAllergiesWarningStatus }
)(AllergiesModal);

/**
 * A single row in the allergy details modal table - corresponding to a weekday
 */
class AllergyInformationRow extends React.Component {
  render() {
    
    const { weekdayName, weekdayIndex, allergyInformationList } = this.props;
    
    let allergyDetail = allergyInformationList[weekdayIndex];
    if (allergyDetail === "") {
      allergyDetail = "None";
    }
    
    return (
      <tr key={weekdayIndex}>
        <td className="allergy-information__weekday-cell">{weekdayName}</td>
        <td className="allergy-information__detail-cell">{allergyDetail}</td>
      </tr>
    );
    
  }
}



// WEBPACK FOOTER //
// ./src/components/school_money/dinners/AllergiesModal.js